module.exports = __webpack_public_path__ + "static/media/alert.daa9c2e2.svg";